// AUDIO
export const FB_EVT_STREAMED_EPISODE_START = 'streamed_episode_start';
export const FB_EVT_STREAMED_EPISODE = 'streamed_episode';

// AUTH
export const FB_EVT_LOGGED_IN = 'logged_in';
export const FB_EVT_LOGGED_OUT = 'logged_out';

// BASIC
export const FB_EVT_PAGE_VIEW = 'PageView';